import React, { useState, useEffect, useRef } from "react";
import SbEditable from "storyblok-react";
import RichText from "src/utils/RichText";
import ScribbleBackground from "src/static/scribble_background.png";

const ContentCenteredRework = ({ blok }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); 
        }
      },
      { threshold: 0.3 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div ref={ref} className="bg-white relative">
        {/* Background Image */}
        <div className="hidden absolute md:block top-0 right-0">
          <img src={ScribbleBackground} alt="scribble background" className="" />
        </div>

        {/* Content Wrapper */}
        <div className="max-w-7xl mx-auto py-16 lg:py-24 px-6 flex flex-col lg:flex-row justify-between lg:items-center gap-8">
          <div className="max-w-3xl">
            <h3
              className={`h3 text-orange mb-5 lg:mb-10 transition-all duration-1000 ease-out transform ${
                isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"
              }`}
            >
              {blok.title}
            </h3>
            <div
              className={`medium-body-text rich-text transition-all duration-1000 ease-out transform delay-200 ${
                isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"
              }`}
            >
              <RichText>{blok.content}</RichText>
            </div>
          </div>
        </div>
      </div>
    </SbEditable>
  );
};

export default ContentCenteredRework;
